var _g, _g2, _path, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorshipMapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1989_9853)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5183,
    cy: 39.5781,
    rx: 5.1726,
    ry: 1.84736,
    fill: "black",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1989_9853)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5178 3C28.0881 3 35.0356 9.94756 35.0356 18.5178C35.0356 25.0889 30.9513 30.7061 25.1828 32.9691L20.4017 39.5043C20.302 39.6411 20.1696 39.7528 20.0158 39.8298C19.862 39.9069 19.6912 39.9472 19.5178 39.9472C19.3445 39.9472 19.1736 39.9069 19.0198 39.8298C18.866 39.7528 18.7336 39.6411 18.634 39.5043L13.8528 32.9691C8.08433 30.7061 4 25.0889 4 18.5178C4 9.94756 10.9476 3 19.5178 3Z",
    fill: "#00A997"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1241 18.562C32.1241 11.6242 26.4999 6 19.562 6C12.6242 6 7 11.6242 7 18.562C7 25.4999 12.6242 31.1241 19.562 31.1241C26.4999 31.1241 32.1241 25.4999 32.1241 18.562Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1989_9853)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1989_9853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2334 22.6003H20.8063V26.0147H19.2334V22.6003Z",
    fill: "#3F51B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8754 19.5696V15.0044H25.4483L20.5762 12.3189V10.4008H21.7271V9.24988H20.5762V7.98389H19.4253V9.21151H18.2744V10.3624H19.4253V12.3189L14.5531 15.0044H16.126V19.5696H10.9854V26.0147H18.0442V21.4494H21.9573V26.0147H29.0161V19.5696H23.8754ZM13.9393 24.0198H12.7884V21.8714H13.9393V24.0198ZM16.4329 24.0198H15.282V21.8714H16.4329V24.0198ZM19.502 18.8023H18.3511V17.6514H19.502V18.8023ZM19.502 16.7691H18.3511V15.6182H19.502V16.7691ZM21.6504 18.8023H20.4995V17.6514H21.6504V18.8023ZM21.6504 16.7691H20.4995V15.6182H21.6504V16.7691ZM24.7194 24.0198H23.5685V21.8714H24.7194V24.0198ZM27.213 24.0198H26.0621V21.8714H27.213V24.0198Z",
    fill: "#3F51B5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1989_9853",
    x: 12.8678,
    y: 36.2528,
    width: 13.3005,
    height: 6.65064,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.738955,
    result: "effect1_foregroundBlur_1989_9853"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1989_9853",
    x: 0.305226,
    y: 0.0441809,
    width: 38.4247,
    height: 44.3368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.738955
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84739
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1989_9853"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1989_9853",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1989_9853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1989_9853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4144,
    height: 18.4144,
    fill: "white",
    transform: "translate(10.793 7.79272)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorshipMapIcon);
export default __webpack_public_path__ + "static/media/worshipMapIcon.9acc0a93985bbd05bfdb32cbcdeca043.svg";
export { ForwardRef as ReactComponent };